import { api, publicClient } from 'api/client';
import { API_ENDPOINTS } from 'config/api.config';
import { 
  LoginRequest, 
  RegisterRequest, 
  ChangePasswordRequest, 
  ResetPasswordRequest,
  AuthResponse,
  User,
  RefreshTokenRequest,
  AuthTokens
} from 'types/user.types';
import { SuccessResponse } from 'types/api.types';

export const authApi = {
  login: async (data: LoginRequest): Promise<AuthResponse> => {
    const response = await publicClient.post<AuthResponse>(
      API_ENDPOINTS.auth.login,
      data
    );
    return response.data;
  },

  refresh: async (data: RefreshTokenRequest): Promise<{ tokens: AuthTokens }> => {
    const response = await publicClient.post<{ tokens: AuthTokens }>(
      API_ENDPOINTS.auth.refresh,
      data
    );
    return response.data;
  },

  resetPassword: async (data: ResetPasswordRequest): Promise<SuccessResponse & { temp_password: string }> => {
    const response = await publicClient.post<SuccessResponse & { temp_password: string }>(
      API_ENDPOINTS.auth.resetPassword,
      data
    );
    return response.data;
  },

  register: async (data: RegisterRequest): Promise<SuccessResponse & { user: User }> => {
    const response = await api.post<SuccessResponse & { user: User }>(
      API_ENDPOINTS.auth.register,
      data
    );
    return response.data;
  },

  logout: async (): Promise<SuccessResponse> => {
    const response = await api.post<SuccessResponse>(
      API_ENDPOINTS.auth.logout
    );
    return response.data;
  },

  me: async (): Promise<{ user: User }> => {
    const response = await api.get<{ user: User }>(
      API_ENDPOINTS.auth.me
    );
    return response.data;
  },

  changePassword: async (data: ChangePasswordRequest): Promise<SuccessResponse> => {
    const response = await api.post<SuccessResponse>(
      API_ENDPOINTS.auth.changePassword,
      data
    );
    return response.data;
  },

  validateToken: async (): Promise<{ valid: boolean; user_id: number }> => {
    const response = await api.get<{ valid: boolean; user_id: number }>(
      API_ENDPOINTS.auth.validate
    );
    return response.data;
  },
};